import { DebugLogger } from './utils/logger';

// Simple runtime public path setter using page path check for `/as-c0/`.
// This minimal approach sets the bundler public path to either
// `/as-c0/statics-oauth-client-nn/js/` when the page path contains `/as-c0/`,
// or `/statics-oauth-client-nn/js/` otherwise.

const BASE_PATH_PINGAM = '/statics-oauth-client-nn/js/';

if (typeof window !== 'undefined') {
  const isCallops = window.location.pathname.includes('/as-c0/');
  const base = (isCallops ? '/as-c0' : '') + BASE_PATH_PINGAM;
  // @ts-ignore - rspack/webpack runtime public path
  (globalThis as any).__webpack_public_path__ = base;
}

DebugLogger.info(
  'Set __webpack_public_path__ to:',
  (globalThis as any).__webpack_public_path__
);
